<template>
  <div class="ni-toolbar">
    <span class="ni-toolbar__title">NATS Inspector</span>

    <div class="ni-toolbar__filters">
      <button
        v-for="opt in kindOptions"
        :key="opt.value"
        class="ni-toolbar__kind-btn"
        :class="{ 'ni-toolbar__kind-btn--active': store.filterKind === opt.value }"
        @click="store.filterKind = opt.value"
      >{{ opt.label }}</button>
    </div>

    <input
      v-model="store.filterSubject"
      type="text"
      class="ni-toolbar__search"
      placeholder="Фильтр по subject..."
    />

    <span class="ni-toolbar__count">
      {{ store.filtered.length }}<span class="ni-toolbar__count-sep">/</span>{{ store.entries.length }}
    </span>

    <button class="ni-toolbar__btn" title="Очистить" @click="store.clear()">
      &#x2715; clear
    </button>

    <span class="ni-toolbar__spacer" />

    <button class="ni-toolbar__btn ni-toolbar__btn--close" title="Закрыть (Ctrl+Q)" @click="store.toggle()">
      &#x2715;
    </button>
  </div>
</template>

<script setup lang="ts">
import { useNatsInspectorStore } from './inspector-store'

const store = useNatsInspectorStore()

const kindOptions = [
  { value: 'all' as const, label: 'All' },
  { value: 'request' as const, label: 'Req' },
  { value: 'event' as const, label: 'Evt' },
]
</script>

<style scoped>
.ni-toolbar {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 12px;
  border-bottom: 1px solid #333;
  flex-shrink: 0;
}

.ni-toolbar__title {
  font-size: 14px;
  font-weight: 700;
  color: #eee;
  letter-spacing: 0.5px;
  margin-right: 4px;
}

.ni-toolbar__filters {
  display: flex;
  gap: 2px;
}

.ni-toolbar__kind-btn {
  background: #2a2a2a;
  border: 1px solid #444;
  color: #aaa;
  font-size: 11px;
  padding: 2px 8px;
  cursor: pointer;
  border-radius: 3px;
}

.ni-toolbar__kind-btn--active {
  background: #3a3a4a;
  color: #fff;
  border-color: #667;
}

.ni-toolbar__kind-btn:hover {
  border-color: #888;
}

.ni-toolbar__search {
  flex: 1;
  min-width: 120px;
  max-width: 300px;
  background: #222;
  border: 1px solid #444;
  color: #ddd;
  font-size: 12px;
  padding: 3px 8px;
  border-radius: 4px;
  outline: none;
  font-family: 'Consolas', 'Monaco', 'Courier New', monospace;
}

.ni-toolbar__search:focus {
  border-color: #6079af;
}

.ni-toolbar__search::placeholder {
  color: #666;
}

.ni-toolbar__count {
  font-size: 11px;
  color: #888;
  flex-shrink: 0;
}

.ni-toolbar__count-sep {
  color: #555;
  margin: 0 1px;
}

.ni-toolbar__spacer {
  flex: 1;
}

.ni-toolbar__btn {
  background: none;
  border: 1px solid #444;
  color: #aaa;
  font-size: 11px;
  padding: 2px 8px;
  border-radius: 3px;
  cursor: pointer;
  flex-shrink: 0;
}

.ni-toolbar__btn:hover {
  border-color: #888;
  color: #ddd;
}

.ni-toolbar__btn--close {
  font-size: 14px;
  padding: 0 6px;
  line-height: 1.4;
}
</style>
